import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import recordSurveyImpression from '@/api/teacher/surveys/recordSurveyImpression.endpoint';

import { floatingSurveyQueryKey } from '../constants/constants';

export default function useRecordSurveyImpressionMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: recordSurveyImpression,
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [QUERY_KEYS.SURVEYS, floatingSurveyQueryKey],
      });
    },
    meta: {
      notification: {
        error: "We couldn't record the survey. Please try again.",
      },
    },
  });
}
